var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 13.25H2.16667C1.85725 13.25 1.5605 13.1271 1.34171 12.9083C1.12292 12.6895 1 12.3928 1 12.0833V3.91667C1 3.60725 1.12292 3.3105 1.34171 3.09171C1.5605 2.87292 1.85725 2.75 2.16667 2.75H4.49957L5.66624 1H10.3329L11.4996 2.75H13.8333C14.1428 2.75 14.4395 2.87292 14.6583 3.09171C14.8771 3.3105 15 3.60725 15 3.91667V12.0833C15 12.3928 14.8771 12.6895 14.6583 12.9083C14.4395 13.1271 14.1428 13.25 13.8333 13.25Z",
    stroke: "#D70926",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98828 10.3311C9.43803 10.3311 10.6133 9.1558 10.6133 7.70605C10.6133 6.25631 9.43803 5.08105 7.98828 5.08105C6.53853 5.08105 5.36328 6.25631 5.36328 7.70605C5.36328 9.1558 6.53853 10.3311 7.98828 10.3311Z",
    stroke: "#D70926",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c1558851.svg";
export { ForwardRef as ReactComponent };